import { createAsyncThunk } from '@reduxjs/toolkit';
import { getMyPermissionsService } from '@shared/services/get-my-permissions.service';

export const getPermissionsAction = createAsyncThunk(
  'user/permissions',
  async (_, { rejectWithValue }) => {
    try {
      const result = await getMyPermissionsService();
      return result;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue(error.message);
      }
    }
  },
);
